import Sidebar from './common/Sidebar';
import TaskIcon from 'assets/icons/task';
import ConditionIcon from 'assets/icons/condition';
import { Box, Typography } from '@mui/material';
import SaveIcon from '@mui/icons-material/Save';
import SolutionShape from './shapes/SolutionShape';
import ConditionShape from './shapes/ConditionShape';
import ConfirmModal from 'components/modal/ConfirmModal';
import ActionButton from 'components/button/ActionButton';
import SolutionTaskShape from './shapes/SolutionTaskShape';
import { Controls, ReactFlow, Background } from '@xyflow/react';
import useCreateWorkFlowHook from './hooks/useCreateWorkFlowHook';
import EdgeConfigurationDrawer from './drawer/EdgeConfigurationDrawer';
import NodeConfigurationDrawer from './drawer/NodeConfigurationDrawer';

const SubmitButton = ({ handleSubmit, isLoading, handleCreateSolution }) => {
	return (
		<Box
			sx={{
				gap: 1,
				top: 16,
				right: 16,
				zIndex: 999,
				display: 'flex',
				alignItems: 'center',
				// position: 'absolute',
			}}
		>
			<ActionButton onClick={handleCreateSolution} variantType="add" label="Solution" tooltip="Create Solution" />
			<ActionButton onClick={handleSubmit} startIcon={<SaveIcon />} variantType="save" label="Save" tooltip="Save workflow" />
		</Box>
	);
};

const nodeTypes = {
	solution: SolutionShape,
	condition: ConditionShape,
	solution_task: SolutionTaskShape,
};

// const Sidebar = () => {
// 	const onDragStart = (event, nodeType) => {
// 		event.dataTransfer.setData('application/reactflow', nodeType);
// 		event.dataTransfer.effectAllowed = 'move';
// 	};

// 	return (
// 		<aside style={{ padding: 10, borderRight: '1px solid #ddd', background: '#fff' }}>
// 			<Box
// 				draggable
// 				onDragStart={(e) => onDragStart(e, 'solution_task')}
// 				sx={{
// 					cursor: 'grab',
// 					marginBottom: 10,
// 					background: '#eee',
// 					padding: '10px 10px 5px 10px',
// 				}}
// 			>
// 				<TaskIcon />
// 			</Box>

// 			<Box
// 				draggable
// 				onDragStart={(e) => onDragStart(e, 'condition')}
// 				sx={{
// 					cursor: 'grab',
// 					background: '#eee',
// 					padding: '10px 10px 5px 10px',
// 				}}
// 			>
// 				<ConditionIcon />
// 			</Box>
// 		</aside>
// 	);
// };

const Header = ({ isLoading, handleCreateSolution, setShowModal, nodes }) => {
	const solutionData = nodes?.find((item) => item?.type === 'solution')?.data ?? null;

	return (
		<Box
			sx={{
				display: 'flex',
				marginTop: '40px',
				background: '#fff',
				alignItems: 'center',
				// p: '10px 24px 10px 65px',
				p: '10px 24px 10px 24px',
				justifyContent: 'space-between',
				borderBottom: '1px solid #E5E7EB',
				boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.05)',
			}}
		>
			<Box>
				<Typography fontWeight={600} fontSize={18} sx={{ color: solutionData?.solution?.name ? '#1F2937' : '#EF4444' }}>
					{solutionData?.solution?.name ?? 'Please create solution first'}
				</Typography>

				<Typography fontWeight={400} fontSize={14} sx={{ color: solutionData?.solution?.verticalName ? '#6B7280' : '#EF4444' }}>
					Vertical: {solutionData?.solution?.verticalName ?? 'No vertical selected'}
				</Typography>
			</Box>

			<SubmitButton handleSubmit={() => setShowModal(true)} isLoading={isLoading} handleCreateSolution={handleCreateSolution} />
		</Box>
	);
};

const WorkflowCreate = () => {
	const {
		nodes,
		edges,
		onDrop,
		setEdges,
		isLoading,
		setNodes,
		showModal,
		onConnect,
		onDragOver,
		isModalOpen,
		handleSubmit,
		setShowModal,
		flowInstance,
		selectedNode,
		selectedEdge,
		onNodesChange,
		onEdgesChange,
		setIsModalOpen,
		setSelectedNode,
		isEdgeModalOpen,
		setSelectedEdge,
		reactFlowWrapper,
		setIsEdgeModalOpen,
		handleCreateSolution,

		onAddNode,
	} = useCreateWorkFlowHook();

	return (
		<>
			<Header isLoading={isLoading} handleCreateSolution={handleCreateSolution} setShowModal={setShowModal} nodes={nodes} />

			<Box sx={{ display: 'flex', height: '85vh', position: 'relative' }}>
				{/* <Sidebar /> */}

				<Box sx={{ flex: 1 }} ref={reactFlowWrapper}>
					<ReactFlow
						fitView
						nodes={nodes}
						edges={edges}
						onDrop={onDrop}
						nodeTypes={nodeTypes}
						onConnect={onConnect}
						onDragOver={onDragOver}
						onNodesChange={onNodesChange}
						onEdgesChange={onEdgesChange}
						onInit={(instance) => (flowInstance.current = instance)}
						onNodeClick={(event, node) => {
							setSelectedNode(node);
							setIsModalOpen(true);
						}}
						onEdgeClick={(event, edge) => {
							setSelectedEdge(edge);
							setIsEdgeModalOpen(true);
						}}
					>
						<Controls />
						<Background />
					</ReactFlow>

					{/* <SubmitButton handleSubmit={() => setShowModal(true)} isLoading={isLoading} handleCreateSolution={handleCreateSolution} /> */}
				</Box>

				{isModalOpen && selectedNode && (
					<NodeConfigurationDrawer
						edges={edges}
						nodes={nodes}
						node={selectedNode}
						setNodes={setNodes}
						setEdges={setEdges}
						onClose={() => setIsModalOpen(false)}
					/>
				)}

				{isEdgeModalOpen && selectedEdge && (
					<EdgeConfigurationDrawer edge={selectedEdge} setEdges={setEdges} setNodes={setNodes} onClose={() => setIsEdgeModalOpen(false)} />
				)}

				{showModal && (
					<ConfirmModal
						showModal={showModal}
						handleSubmit={handleSubmit}
						setShowModal={setShowModal}
						modalData={{
							head: 'Workflow create',
							label: (
								<p>
									Do you want to <b style={{ fontSize: '1rem' }}>Create</b> ?
								</p>
							),
						}}
					/>
				)}
			</Box>
		</>
	);
};

export default WorkflowCreate;
